import React from "react";
import { Navigate, RouteObject } from "react-router-dom";
import Login from "../pages/Login";
import Home from "../pages/Home";
import UserPrivacyAgreement from "../pages/UserPrivacyAgreement";
import Unauthorized from "../pages/Unauthorized";
import UserManagement from "../pages/user";
import LoginRecordPage from "../pages/login-record";
import TokenConfigPage from "../pages/token/TokenConfig";
import TokenRecordsPage from "../pages/token/TokenRecords";
import DictManagementPage from "../pages/dict";
import TaskManagementPage from "../pages/task";
import OrgManagementPage from "../pages/org";
import VipManagementPage from "../pages/vip";
import StatDashboardPage from "../pages/stat";
import TokenManager from "../utils/tokenManager";

// 受保护的路由组件
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  // 检查是否有有效的 token
  if (!TokenManager.hasValidToken()) {
    // 如果没有有效的 token，重定向到登录页
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

// 公共路由组件
const PublicRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // 如果已经登录，重定向到用户管理页面
  if (TokenManager.hasValidToken()) {
    return <Navigate to="/users" replace />;
  }

  return <>{children}</>;
};

// 路由配置
const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: (
      <PublicRoute>
        <Login />
      </PublicRoute>
    ),
  },
  {
    path: "/unauthorized",
    element: <Unauthorized />,
  },
  {
    path: "/users",
    element: (
      <ProtectedRoute>
        <UserManagement />
      </ProtectedRoute>
    ),
  },
  {
    path: "/login-records",
    element: (
      <ProtectedRoute>
        <LoginRecordPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/token-config",
    element: (
      <ProtectedRoute>
        <TokenConfigPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/token-records",
    element: (
      <ProtectedRoute>
        <TokenRecordsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dict",
    element: (
      <ProtectedRoute>
        <DictManagementPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/tasks",
    element: (
      <ProtectedRoute>
        <TaskManagementPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/orgs",
    element: (
      <ProtectedRoute>
        <OrgManagementPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/vip",
    element: (
      <ProtectedRoute>
        <VipManagementPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/stat",
    element: (
      <ProtectedRoute>
        <StatDashboardPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/user-privacy-agreement",
    element: <UserPrivacyAgreement />,
  },
  {
    path: "*",
    element: <Navigate to="/login" replace />,
  },
];

export default routes;
